/* v2 : barre défilante (pause), galerie (points + compteur), cartes (flèches), barre d'achat collante. Sans dépendance. */
(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  // Bonus de lancement : date fixe (2026-11-30 23:59 heure du Centre). Après : blocs retirés, case +12 $ de retour.
  var LAUNCH_END = 1796104800000;
  function launchCheck() {
    if (Date.now() < LAUNCH_END) return;
    document.querySelectorAll('[data-rb-launch]').forEach(function (n) { n.remove(); });
    document.querySelectorAll('[data-rb-launch-after][hidden]').forEach(function (n) { n.hidden = false; });
  }
  ready(function () {
    launchCheck(); setInterval(launchCheck, 30000);
    function openTerms() { var d = location.hash === '#launch-terms' && document.getElementById('launch-terms'); if (d) d.open = true; }
    openTerms(); window.addEventListener('hashchange', openTerms);
    // Barre défilante : bouton pause (WCAG 2.2.2)
    document.querySelectorAll('[data-rb2-tick-pause]').forEach(function (b) {
      b.addEventListener('click', function () {
        var t = b.closest('[data-rb2-tick]'); var on = t.classList.toggle('paused');
        b.setAttribute('aria-pressed', on ? 'true' : 'false'); var ic = b.querySelector('[data-rb2-tick-icon]'); if (ic) ic.textContent = on ? '▶' : 'II';
      });
    });
    // Galerie : points + compteur synchronisés au défilement
    document.querySelectorAll('[data-rb2-gal]').forEach(function (g) {
      var track = g.querySelector('.track'); if (!track) return;
      var dots = g.querySelectorAll('.dots button, .thumbs button'); var idx = g.querySelector('[data-rb2-gal-i]');
      function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
      track.addEventListener('scroll', function () {
        var i = cur(); if (idx) idx.textContent = i + 1;
        dots.forEach(function (d, k) { if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }, { passive: true });
      dots.forEach(function (d, k) { d.addEventListener('click', function () { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }); });
    });
    // Cartes : flèches
    document.querySelectorAll('.rb2-cards').forEach(function (s) {
      var t = s.querySelector('[data-rb2-track]'); if (!t) return;
      function step() { var c = t.querySelector('li'); return c ? c.getBoundingClientRect().width + 14 : 300; }
      var p = s.querySelector('[data-rb2-prev]'), n = s.querySelector('[data-rb2-next]');
      if (p) p.addEventListener('click', function () { t.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (n) n.addEventListener('click', function () { t.scrollBy({ left: step(), behavior: 'smooth' }); });
    });
    // Barre collante : cachée tant qu'un bloc « héros / achat » ou le pied de page est visible
    var sticky = document.querySelector('[data-rb2-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var watch = Array.prototype.slice.call(document.querySelectorAll('[data-rb2-sticky-hide], .rb-site-footer'));
      var seen = new Map();
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { seen.set(e.target, e.isIntersecting); });
        var show = true; seen.forEach(function (v) { if (v) show = false; });
        sticky.classList.toggle('on', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('a,button').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
      });
      watch.forEach(function (w) { io.observe(w); });
      var sub = sticky.querySelector('[data-rb2-sticky-submit]');
      if (sub) sub.addEventListener('click', function () {
        var f = document.querySelector('[data-rb-product-form]');
        if (f) { if (f.requestSubmit) f.requestSubmit(); else f.submit(); }
      });
    }
  });
})();
